/**
 * 公共配置统一缓存：一次 GET /config/platform-profile 同时供品牌（登录页 Logo/名称）、
 * 平台资质（Center）、客服（客服中心/商品详情/订单详情）消费——全会话单条 HTTP。
 * 法律长文不进此缓存：按需单独拉 /legal/:type（打开弹窗才请求，避免首页下载整篇协议）。
 */
import axios from 'axios'

const EMPTY = {
  platformName: '',
  shopShortName: '',
  logoUrl: '',
  companyName: '',
  unifiedSocialCreditCode: '',
  legalRepresentative: '',
  registeredCapital: '',
  foundedDate: '',
  registeredAddress: '',
  pickupAddress: '',
  businessScope: '',
  contactEmail: '',
  icpRecordNumber: '',
  businessLicenseImage: '',
  customerService: { name: '客服中心', phone: '', hours: '' },
  // 公开配送联系电话（2026-09-22 员工手机号隐私边界）：用户侧"联系配送"拨号目标，
  // 与员工登录手机号解耦——主号空回退客服电话，仍空隐藏拨号入口
  deliveryContact: { phone: '', phoneSecondary: '' },
  showHuiliangzhengBadge: true // "惠/靓/正"角标开关：默认显示（拉取失败降级也不隐藏角标）
}

let cache = null
let pending = null

// 同步读缓存（null=本次会话还没拉到）——router 拼 Tab 标题店铺名后缀用，不发请求
export function getPublicConfig () {
  return cache
}

// 店铺短展示名统一 resolver（单一收口，2026-09-14）：店铺简称 → 店铺名称，都空返回 ''。
// 禁止在此 fallback 系统品牌——路维智联是软件提供方不是店铺招牌（2026-09-11 两层分离纪律）；
// 欢迎语/内页 title 后缀由调用方按空值各自降级，仅浏览器标题 formatter 允许空时拼品牌（任务书 Case C）。
export function resolveShopShortName (cfg) {
  const c = cfg || {}
  return ((c.shopShortName || '').trim()) || ((c.platformName || '').trim()) || ''
}

export function fetchPublicConfig (force) {
  if (!force && cache) return Promise.resolve(cache)
  if (!force && pending) return pending
  pending = axios.get('/config/platform-profile')
    .then(res => {
      const d = res.data && res.data.code === 200 && res.data.data
      cache = d
        ? { ...EMPTY, ...d, customerService: { ...EMPTY.customerService, ...(d.customerService || {}) }, deliveryContact: { ...EMPTY.deliveryContact, ...(d.deliveryContact || {}) } }
        : { ...EMPTY, customerService: { ...EMPTY.customerService }, deliveryContact: { ...EMPTY.deliveryContact } }
      return cache
    })
    .catch(() => {
      // 拉取失败按未配置降级：Logo 回 bundle 默认、资质行隐藏、拨号入口隐藏
      cache = { ...EMPTY, customerService: { ...EMPTY.customerService }, deliveryContact: { ...EMPTY.deliveryContact } }
      return cache
    })
    .then(r => { pending = null; return r })
  return pending
}
